import { useState } from "react";
import styles from "./ForgotPassword.module.scss";
import { Input } from "../../components/ui/Input/Input";
import { Button } from "../../components";
import { AuthContainer } from "../../components/AuthContainer/AuthContainer";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../helpers/routes";

export const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email) {
      return;
    }
    navigate(`${ROUTES.forgotPassword}/code`);
  };

  return (
    <AuthContainer
      title="Forgot your password?"
      subtitle="Don’t worry, happens to all of us. Enter your email below to recover your password"
    >
      <form action="POST" className={styles.form} onSubmit={handleSubmit}>
        <Input
          value={email}
          setValue={setEmail}
          id="email"
          type="email"
          label="Email"
          placeholder="example@mail.com"
          required
        />

        <Button type="submit">Submit</Button>
      </form>
    </AuthContainer>
  );
};
